import * as api from '~/Services/Service';
  import * as actions from '~/actionTypes';
  import { toast } from 'react-toastify';

  // Buscar dados do pré-encaminhamento
  export const fetchPreEncaminhamento = codigoFamilia => dispatch => {
    dispatch({ type: actions.FETCHING_PRE_ENCAMINHAMENTO });

    Promise.all([
      api.getRelatorioPreEncaminhamento(codigoFamilia),
      api.getSenhasPreEncaminhamento(codigoFamilia),
    ])
      .then(([relatorio, senhas]) => {
        dispatch({
          type: actions.FETCH_PRE_ENCAMINHAMENTO_SUCCESS,
          payload: { relatorio, senhas },
        });
      })
      .catch(error => {
        console.error(error);
        dispatch({
          type: actions.FETCH_PRE_ENCAMINHAMENTO_ERROR,
          payload: error.message || 'Erro ao carregar dados',
        });
        toast.error('Erro ao carregar dados do pré-encaminhamento');
      });
  };

  // Chamar próxima senha
  export const chamarProximaSenha = (codigoFamilia, senhaEspecifica = null) => dispatch => {
    api
      .chamarProximaSenhaPreEncaminhamento(codigoFamilia, senhaEspecifica)
      .then(senhaChamada => {
        if (senhaChamada && senhaChamada > 0) {
          toast.success(`Senha ${senhaChamada} está sendo chamada no monitor.`);
          dispatch(fetchPreEncaminhamento(codigoFamilia));
        } else {
          toast.info('Todas as senhas geradas na triagem já foram chamadas.');
        }
      })
      .catch(error => {
        console.error(error);
        dispatch({
          type: actions.CHAMAR_PROXIMA_PRE_ERROR,
          payload: error.message,
        });
        toast.error(error.message || 'Erro ao chamar próxima senha');
      });
  };

  // Recall - chamar novamente
  export const recallSenha = (codigoSenha, codigoFamilia) => dispatch => {
    api
      .recallSenhaPreEncaminhamento(codigoSenha)
      .then(() => {
        dispatch({
          type: actions.RECALL_SENHA_PRE_SUCCESS,
          payload: { codigo: codigoSenha },
        });
        toast.success('Senha chamada novamente.');
        dispatch(fetchPreEncaminhamento(codigoFamilia));
      })
      .catch(error => {
        console.error(error);
        toast.error(error.message || 'Erro ao chamar senha novamente');
      });
  };

  // Toggle ativo/inativo
  export const toggleSenha = (codigoSenha, codigoFamilia) => dispatch => {
    api
      .toggleSenhaPreEncaminhamento(codigoSenha)
      .then(response => {
        dispatch({
          type: actions.TOGGLE_SENHA_PRE_SUCCESS,
          payload: { codigo: codigoSenha, is_ativo: response.is_ativo },
        });
        toast.success(response.is_ativo ? 'Senha reativada.' : 'Senha desativada.');
      })
      .catch(error => {
        console.error(error);
        toast.error(error.message || 'Erro ao alterar status da senha');
      });
  };

  // Atualizar painel (pré-encaminhamento) — dispara SignalR PainelAtualizar
  export const atualizarPainelPre = codigoFamilia => () => {
    api
      .atualizarPainelPreEncaminhamento(codigoFamilia)
      .then(() => {
        toast.success('Painel de senhas atualizado.');
      })
      .catch(error => {
        console.error(error);
        toast.error(error.message || 'Erro ao atualizar painel');
      });
  };

  // Encaminhar senha
  export const encaminharSenha = (codigoSenha, codigoFamilia) => dispatch => {
    api
      .encaminharSenhaPreEncaminhamento(codigoSenha)
      .then(() => {
        dispatch({
          type: actions.ENCAMINHAR_SENHA_PRE_SUCCESS,
          payload: { codigo: codigoSenha },
        });
        toast.success('Cliente encaminhado com sucesso.');
        dispatch(fetchPreEncaminhamento(codigoFamilia));
      })
      .catch(error => {
        console.error(error);
        toast.error(error.message || 'Erro ao encaminhar senha');
      });
  };
  
   // Buscar dados do encaminhamento
  export const fetchEncaminhamento = codigoFamilia => dispatch => {
    dispatch({ type: actions.FETCHING_ENCAMINHAMENTO });

    Promise.all([
      api.getRelatorioEncaminhamento(codigoFamilia),
      api.getSenhasEncaminhamento(codigoFamilia),
      api.getMesasEncaminhamento(codigoFamilia),
    ])
      .then(([relatorio, senhas, mesas]) => {
        dispatch({
          type: actions.FETCH_ENCAMINHAMENTO_SUCCESS,
          payload: { relatorio, senhas, mesas },
        });
      })
      .catch(error => {
        console.error(error);
        dispatch({
          type: actions.FETCH_ENCAMINHAMENTO_ERROR,
          payload: error.message || 'Erro ao carregar dados',
        });
        toast.error('Erro ao carregar dados do encaminhamento');
      });
  };

  // Chamar próxima senha
  export const chamarProximaSenhaEnc = codigoFamilia => dispatch => {
    api
      .chamarProximaSenhaEncaminhamento(codigoFamilia)
      .then(response => {
        if (response && response.success && response.senha > 0) {
          toast.success(`Senha ${response.senha} está sendo chamada no monitor.`);
          dispatch(fetchEncaminhamento(codigoFamilia));
        } else {
          toast.info(response.message || 'Todas as senhas já foram chamadas.');
        }
      })
      .catch(error => {
        console.error(error);
        dispatch({
          type: actions.CHAMAR_PROXIMA_ENC_ERROR,
          payload: error.message,
        });
        toast.error(error.message || 'Erro ao chamar próxima senha');
      });
  };

  // Recall - chamar novamente
  export const recallSenhaEnc = (codigoSenha, codigoFamilia) => dispatch => {
    api
      .recallSenhaEncaminhamento(codigoSenha)
      .then(() => {
        dispatch({
          type: actions.RECALL_SENHA_ENC_SUCCESS,
          payload: { codigo: codigoSenha },
        });
        toast.success('Senha chamada novamente.');
        dispatch(fetchEncaminhamento(codigoFamilia));
      })
      .catch(error => {
        console.error(error);
        toast.error(error.message || 'Erro ao chamar senha novamente');
      });
  };

  // Toggle ativo/inativo
  export const toggleSenhaEnc = (codigoSenha, codigoFamilia) => dispatch => {
    api
      .toggleSenhaEncaminhamento(codigoSenha)
      .then(response => {
        dispatch({
          type: actions.TOGGLE_SENHA_ENC_SUCCESS,
          payload: { codigo: codigoSenha, is_ativo: response.is_ativo },
        });
        toast.success(response.is_ativo ? 'Senha reativada.' : 'Senha desativada.');
        dispatch(fetchEncaminhamento(codigoFamilia));
      })
      .catch(error => {
        console.error(error);
        toast.error(error.message || 'Erro ao alterar status da senha');
      });
  };

  // Atualizar painel (encaminhamento) — dispara SignalR PainelAtualizar
  export const atualizarPainelEnc = codigoFamilia => () => {
    api
      .atualizarPainelEncaminhamento(codigoFamilia)
      .then(() => {
        toast.success('Painel de senhas atualizado.');
      })
      .catch(error => {
        console.error(error);
        toast.error(error.message || 'Erro ao atualizar painel');
      });
  };

  // Encaminhar para mesa
  export const encaminharParaMesaEnc = (codigoSenha, codigoFamilia, mesaEspecifica = null) => dispatch => {
    api
      .encaminharParaMesa(codigoSenha, codigoFamilia, mesaEspecifica)
      .then(() => {
        dispatch({
          type: actions.ENCAMINHAR_MESA_SUCCESS,
          payload: { codigo: codigoSenha },
        });
        toast.success('Senha encaminhada para a mesa com sucesso.');
        dispatch(fetchEncaminhamento(codigoFamilia));
      })
      .catch(error => {
        console.error(error);
        toast.error(error.message || 'Erro ao encaminhar para mesa');
      });
  };

  // Buscar dados do encaminhamento assinatura
  export const fetchAssinatura = codigoFamilia => dispatch => {
    dispatch({ type: actions.FETCHING_ASSINATURA });

    Promise.all([
      api.getRelatorioAssinatura(codigoFamilia),
      api.getSenhasAssinatura(codigoFamilia),
    ])
      .then(([relatorio, senhas]) => {
        dispatch({
          type: actions.FETCH_ASSINATURA_SUCCESS,
          payload: { relatorio, senhas },
        });
      })
      .catch(error => {
        console.error(error);
        dispatch({
          type: actions.FETCH_ASSINATURA_ERROR,
          payload: error.message || 'Erro ao carregar dados',
        });
        toast.error('Erro ao carregar dados do encaminhamento assinatura');
      });
  };

  // Chamar senha para assinatura
  export const chamarAssinatura = (codigoSenha, codigoFamilia) => dispatch => {
    api
      .chamarSenhaAssinatura(codigoSenha)
      .then(() => {
        dispatch({
          type: actions.CHAMAR_ASSINATURA_SUCCESS,
          payload: { codigo: codigoSenha },
        });
        toast.success('Senha chamada para assinatura.');
        dispatch(fetchAssinatura(codigoFamilia));
      })
      .catch(error => {
        console.error(error);
        toast.error(error.message || 'Erro ao chamar senha para assinatura');
      });
  };

  // Recall - chamar novamente para assinatura
  export const recallAssinatura = (codigoSenha, codigoFamilia) => dispatch => {
    api
      .recallSenhaAssinatura(codigoSenha)
      .then(() => {
        dispatch({
          type: actions.RECALL_ASSINATURA_SUCCESS,
          payload: { codigo: codigoSenha },
        });
        toast.success('Senha chamada novamente.');
        dispatch(fetchAssinatura(codigoFamilia));
      })
      .catch(error => {
        console.error(error);
        toast.error(error.message || 'Erro ao chamar senha novamente');
      });
  };

  // Entrada de senha específica
  export const entradaEspecifica = (codigoFamilia, senha, atendimentoPreferencial) => dispatch => {
    api
      .entradaSenhaEspecifica(codigoFamilia, senha, atendimentoPreferencial)
      .then(response => {
        dispatch({
          type: actions.ENTRADA_ESPECIFICA_SUCCESS,
          payload: { senha },
        });
        if (!response.atendimentoFinalizado && response.success) {
          toast.warning(response.message);
        } else if (response.success) {
          toast.success(response.message || 'Senha chamada.');
        }
        dispatch(fetchAssinatura(codigoFamilia));
      })
      .catch(error => {
        console.error(error);
        toast.error(error.message || 'Erro ao dar entrada na senha');
      });
  };

  // Marcar comparecimento na assinatura
  export const marcarComparecimento = (codigoSenha, codigoFamilia) => dispatch => {
    api
      .marcarComparecimentoAssinatura(codigoSenha)
      .then(() => {
        dispatch({
          type: actions.MARCAR_COMPARECIMENTO_SUCCESS,
          payload: { codigo: codigoSenha },
        });
        toast.success('Comparecimento registrado com sucesso.');
        dispatch(fetchAssinatura(codigoFamilia));
      })
      .catch(error => {
        console.error(error);
        toast.error(error.message || 'Erro ao registrar comparecimento');
      });
  };

  // Chamar próxima senha para assinatura (com prioridade diamante)
  export const chamarProximaAssinatura = (codigoFamilia) => (dispatch) => {
    api
      .chamarProximaSenhaAssinatura(codigoFamilia)
      .then((response) => {
        if (response.success) {
          toast.success('Próxima senha chamada para assinatura.');
          dispatch(fetchAssinatura(codigoFamilia));
        } else {
          toast.info(response.message || 'Nenhuma senha pendente para assinatura.');
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error(error.message || 'Erro ao chamar próxima senha para assinatura');
      });
  };